import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import CartLineRow from '../components/CartLineRow';
import { useHasProducts } from '../hooks/useHasProducts';
import { formatCents } from '../utils/money';

const Cart: React.FC = () => {
  const { lines, subtotalCents, clear } = useCart();
  const hasProducts = useHasProducts();

  if (lines.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 text-center">
        <h1 className="text-2xl font-semibold mb-3">Your cart is empty</h1>
        {/* Pointing at the shop is only helpful if there's anything in it;
            with an empty catalog a custom request is the way to order. */}
        {hasProducts ? (
          <Link to="/shop" className="text-primary hover:underline">Browse the shop →</Link>
        ) : (
          <>
            <p className="text-text-light mb-4">
              There's nothing in the shop just yet — but everything here is made
              to order anyway.
            </p>
            <Link
              to="/custom-request"
              className="inline-block bg-primary text-white rounded px-5 py-3 text-sm font-medium hover:bg-primary-dark"
            >
              Request a custom piece
            </Link>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-semibold mb-6">Cart</h1>
      <div className="border-t border-background-dark">
        {lines.map(l => (
          <CartLineRow key={`${l.sku}-${JSON.stringify(l.personalization ?? {})}-${l.notes ?? ''}`} line={l} />
        ))}
      </div>

      <div className="flex flex-col-reverse sm:flex-row sm:justify-between sm:items-center gap-4 mt-6">
        <button onClick={clear} className="text-sm text-text-light hover:text-primary">
          Clear cart
        </button>
        <div className="text-right">
          <div className="text-sm text-text-light">Subtotal</div>
          <div className="text-xl font-semibold">{formatCents(subtotalCents)}</div>
          <div className="text-xs text-text-light">Shipping and tax calculated at checkout.</div>
        </div>
      </div>

      <div className="mt-6 flex justify-end gap-3">
        <Link
          to="/shop"
          className="border border-background-dark rounded px-5 py-3 text-sm hover:border-primary"
        >
          Continue shopping
        </Link>
        <Link
          to="/checkout"
          className="bg-primary text-white rounded px-5 py-3 text-sm font-medium hover:bg-primary-dark"
        >
          Checkout
        </Link>
      </div>
    </div>
  );
};

export default Cart;
